module.exports = __webpack_public_path__ + "static/media/video-detail-header-image.943c5efa.png";